module.exports = __webpack_public_path__ + "img/header2.62f7cb54.jpg";